import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';
import { ExtendedAddress } from '../types';
import { Button } from '@/shared/ui';

interface ValidAddressFromFormikValuesProps {
    values: ExtendedAddress;
    hasEdit?: boolean;
    theme?: 'default' | 'green';
    onEditPressed?: () => void;
}

const ValidAddressFromFormikValues: React.FC<ValidAddressFromFormikValuesProps> = ({ theme = 'default', values, hasEdit = true, onEditPressed }) => (
    <div
        data-testid="address-preview-container"
        className={`flex w-full max-w-full items-start rounded-2xl ${theme === 'default' ? 'border-1 border-black' : 'bg-primary-1200'} p-5 lg:py-[1.4375rem] lg:pl-[1.5625rem] lg:pr-5`}
    >
        <div className="max-w-full flex-auto">
            <h4
                data-testid="address-preview-address-line"
                // address text is PII, exclude it from PostHog session recording
                className={`ph-no-capture mb-[4px] w-full overflow-hidden text-ellipsis whitespace-nowrap ${theme === 'default' ? 'font-atkinsonBold' : 'font-dmSansBold font-bold'} uppercase text-18 leading-[133%]`}
            >
                {values.addressLine1} {values.addressLine2}
            </h4>
            <div
                className="flex max-w-full flex-col gap-0.5 overflow-hidden font-atkinsonHyperlegible text-18 leading-[140%]"
                data-testid="address-preview-address-details"
            >
                {values.unit && (
                    <span className={`ph-no-capture w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap break-all ${theme === 'default' ? 'uppercase' : ''}`}>
                        {values.unit}
                    </span>
                )}

                <span className={`ph-no-capture w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap break-all ${theme === 'default' ? 'uppercase' : ''}`}>
                    {values.city}, {values.state} {values.zip}
                </span>
                {/* <span className="break-all font-atkinsonHyperlegible text-sm uppercase lg:text-base">{values.zip}</span> */}
            </div>
        </div>
        {hasEdit && theme === 'default' && (
            <i
                onClick={() => onEditPressed?.()}
                className="icon-pen flex h-[35px] min-w-[35px] cursor-pointer items-center justify-center rounded-full bg-mint-400 font-dmSansBold font-bold text-18 leading-[105%] text-primary"
            />
        )}

        {hasEdit && theme === 'green' && (
            <Button
                variant="text"
                onClick={() => onEditPressed?.()}
                className="no-underline flex h-[35px] min-w-[35px] cursor-pointer text-lg text-primary"
            >
                <span className="font-dmSansMedium font-bold">Edit</span>
            </Button>
        )}
    </div>
);

export default withScrollRestoration(ValidAddressFromFormikValues);
